// all application settings
var Settings = {
    parseAppId: 'synsec',
    parseKey: '',
    parseUrl: 'https://synsec.herokuapp.com/parse',
    deepLinkUrl: '',
    privacityPoliticsURL: 'https://www.shogunmonitor.com/documents/POLITICAS%20DE%20PRIVACIDAD%20SHOGUN%20TECNOLOGIES%20S.A%20%202018.pdf',
    blockscreenshot: false,
    login: false,
    footer: {
      active: true,
      dacor: false,
      links: [
        {
          defaultText: "Política de cookies",
          url: "https://www1.shogunmonitor.com/privacy-policies/cookies-policy.html"
        },
        {
          defaultText: "Política de privacidad",
          url: "https://www1.shogunmonitor.com/privacy-policies/privacy-policy.html"
        },
      ]
  }

};

export const LanguageDefault = { "es" :
{
  "AcceptBtn":"Aceptar",
  "AccepttermsSubtittle":"Para Continuar debe aceptar nuestros Términos y Condiciones de Uso.",
  "AccepttermsSubtittle2":"Siga el siguiente link para conocer más:",
  "AttachBtn":"ADJUNTAR ARCHIVO, IMAGEN o VIDEO",
  "Attachfilesreport":"Archivos adjuntos:",
  "BackBtn":"Regresar",
  "Btn_back":"Regresar",
  "Btn_home":"Inicio",
  "Btn_NewsBack":"Regresar",
  "CheckAttachedFile":"ver enlace adjunto",
  "CheckboxText":"He leído y acepto los Términos y Condiciones de Uso",
  "Comment_send":"ENVIAR",
  "Conferencistas_conferencistas":"Conferencistas",
  "ConsultBtn":"Consultar",
  "CreateCommentPlaceHolder":"Realice un comentario",
  "CreateCommentThks":"Gracias",
  "CreateCommentThksMessage":"Su comentario es valioso para mejorar nuestros procedimientos y nuestra comunidad",
  "CreateCommentTittle":"Comentar reporte",
  "CreateReport":"Creando Reporte",
  "DescPlaceHolder":"¿Qué desea reportar?",
  "Descriptionmsg":"Favor Ingrese la descripción",
  "Filetolarge":"El archivo es muy grande para subir al sistema, favor subir un archivo menor a 80mb",
  "Home_Conferencistas":"Conferencistas",
  "Home_News":"Noticias",
  "Home_Patrocinadores":"Patrocinadores",
  "Home_Programa":"Programa",
  "InfoText":"Compañía proveedora de soluciones tecnológicas para auditoría interna, auditoría externa cumplimiento y gestión de riesgos",
  "InfoText2":"Utilice la herramienta del buscador para encontrar una categoría",
  "InfoText3":"Seleccione una categoría",
  "InsertDetailsReportTittle":"Realizar un reporte sobre",
  "inputsearchcode":"Buscar...",
  "LocalizationModalTittle":"Seleccione un lenguaje",
  "MainTittle":"Línea de Transparencia",
  "MakeQuestionClapfo":"REALIZAR REPORTE",
  "Modal2btn":"Regresar",
  "MyReportsBtn":"Mis Reportes",
  "MyReportsModalInfo":"Estos son los códigos de reportes que ha realizado, seleccione para consultar.",
  "MyReportsModalTittle":"Mis Reportes",
  "NewReportBtn":"Realizar reporte",
  "NewReportForCat":"Crear Reporte de:",
  "News_news":"Noticias",
  "OptionalText":"* Nombre opcional.",
  "Placeholder-home":"Consultar con código",
  "PushNews":"Nueva Noticia",
  "PushRepTitle":"Nuevo",
  "PushSeeMore":"Ver Más",
  "PushSeeReport":"Ver reporte",
  "ReportActivity":"para realizar su denuncia",
  "ReportCommentAdmin":"ADMINISTRADORES",
  "ReportCommentAnonymous":"Usuario Anónimo",
  "ReportCommentsTittle":"Comentarios",
  "ReportDays1":"días",
  "ReportDays2":"Creado hace",
  "ReportDescription":"Seleccione una actividad y realice un reporte",
  "ReportDetailSubTittle":"Descripción del reporte",
  "ReportDetailTittle":"Consulta reporte",
  "ReportNewComment":"Crear comentario",
  "ReportStatus1":"En proceso...",
  "ReportStatus2":"Cerrado",
  "ReportStatus3":"Descartado",
  "search":"Buscar categoría",
  "SelectCategory":"Reporte una actividad",
  "Selectprogram":"Ayuda a mejorar tu empresa notificando sobre problemas que hay en esta",
  "SendBtn":"Enviar Reporte",
  "Singlenews_singlenews":"Noticia",
  "SubsidiaryBtn":"Entra a la filial electrónica",
  "Termnstittle":"Términos y Condiciones de uso",
  "ThksInfo":"Se ha generado un nuevo reporte. Para seguirla sería por medio del siguiente código:",
  "ThksTittle":"Gracias por su reporte",
  "UserNameReportHolder":"Nombre del Denunciante",
  "WarningTittle":"Aviso",
  "CopyBtn":"Copiar",
  "CopiedBtn":"Copiado"
}
}
export default Settings;
